import { Controller, useFormContext } from "react-hook-form";
import { Switch } from "rizzui";

export interface MultipleContactPageProps {
  isSuperAdmin?: boolean;
  name: string;
}

export default function MultipleContactPage({
  isSuperAdmin,
  name,
}: MultipleContactPageProps) {
  const { control } = useFormContext();

  return (
    <div className="grid grid-cols-1 gap-2 w-full">
      <div className="grid w-full items-start gap-32grid-cols-1">
        <h6 className="text-foreground md:text-base">Multiple Contact</h6>
      </div>
      <div className="grid w-full items-start gap-3 grid-cols-1">
        {isSuperAdmin && (
          <Controller
            control={control}
            name={`${name}.enable`}
            render={({ field, fieldState }) => (
              <Switch
                label="Enable"
                size="lg"
                className=" w-auto"
                {...field}
                checked={field.value || false}
                error={fieldState.error?.message}
              />
            )}
          />
        )}
      </div>
    </div>
  );
}
